(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('PlanningDialogController', PlanningDialogController);

    PlanningDialogController.$inject = ['$uibModalInstance', 'entity', '$http', 'AlertService', 'parameters',
        '$rootScope', 'Principal', 'SoopkitchenUtils', '$cookies', '$timeout', 'Planning', 'PlanTypes'];

    function PlanningDialogController($uibModalInstance, entity, $http, AlertService, parameters, $rootScope, Principal,
                                      SoopkitchenUtils, $cookies, $timeout, Planning, PlanTypes) {

        var vm = this;
        vm.planType = parameters.planType;
        vm.isMaster = vm.planType == PlanTypes['master'];
        vm.isChild = vm.planType == PlanTypes['child'];
        vm.isTemplate = vm.planType == PlanTypes['template'];
        vm.isSoop = vm.planType == PlanTypes['soop'];
        vm.isTimelineWithNoDates = vm.isTemplate || vm.isSoop;
        vm.cut = parameters.cut;
        vm.waiting = false;

        vm.roundDecimals = SoopkitchenUtils.roundDecimals;

        vm.isEditable = false;
        vm.repeat = false;
        vm.preserveRatio = getPreserveRatio();
        vm.durationLettersFrequency = 0;
        vm.numberOccurences = 2;
        vm.comment = "";
        vm.selectedExperiment = "";
        vm.selectedModule = "";
        vm.selectedObservation = null;
        vm.obsDef = null;
        vm.dialogTitle = parameters.action;
        vm.blinkingTimeout = 2000;
        vm.ids = [];
        vm.isSocUser = false;
        Principal.hasAnyAuthority(['ROLE_PLAN_COORDINATOR', 'ROLE_POWER_USER']).then(
            function (result) {
                if (result) {
                    vm.isSocUser = true;
                }
            }
        );
        vm.userInstruments = [];
        Principal.getUserInstruments().then(
            function (result) {
                if (result) {
                    vm.userInstruments = result;
                }
            }
        );

        function updateSOOPRelations(soopsItBelongs) {
            vm.soopsItBelongs = soopsItBelongs;
            vm.soopBelonging = [];
            vm.soopsItBelongs.forEach(function (item, index) {
                vm.soopBelonging.push(false);
            });
        }

        updateSOOPRelations(getSOOPsItBelongs());

        if (parameters.locked != null) {
            vm.isEditable = parameters.locked === false;
        }
        if (parameters.occurrence != null) {
            if (parameters.occurrence.hasOwnProperty('ids')) {
                for (var i = 0; i < parameters.occurrence.ids.length; i++) {
                    vm.ids.push(parameters.occurrence.ids[i]);
                }
            }
            vm.operation = "Update";
            if (vm.isEditable === false) {
                vm.operation = "Visualizing";
            }
        }

        vm.occurrence = null;
        vm.evaluatedObservation = null;
        vm.isObsUpdate = false;
        vm.plan = entity;
        vm.observationsPerInstrument = vm.plan.observationDefinitions.allExperimentsObservationDefinitions;
        vm.getObsDef = getObsDef;
        vm.clear = clear;
        vm.clearParameters = clearParameters;
        vm.resetEvaluation = resetEvaluation;
        vm.repeatWrong = repeatWrong;
        vm.getValidityRange = getValidityRange;
        vm.belongsToASOOP = belongsToASOOP;
        vm.savedItems = [];
        if (parameters.occurrence != null) {

            vm.evaluatedObservation = null;
            vm.group = parameters.experiment;
            vm.occurrence = parameters.occurrence;
            setStartDate(parameters.start);
            setEndDate(parameters.end);

            vm.availableExperiments = getExperiments();
            vm.availableModules = vm.observationsPerInstrument[parameters.experiment].modules;

            vm.selectedExperiment = parameters.experiment;
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;

            vm.selectedModule = parameters.module;
            vm.availableObservations = getObservations();

            vm.selectedObservationId = parameters.observation;
            vm.selectedObservation = vm.occurrence;
            vm.obsDef = vm.getObsDef(vm.occurrence);

            vm.isObsUpdate = true;

            updateParametersValues();
        } else {
            vm.operation = "Create";
            vm.group = parameters.group;
            setStartDate(SoopkitchenUtils.formattedDate(parameters.start));
            // same date to start
            setEndDate(getStartDate());

            vm.selectedExperiment = vm.group;
            vm.selectedModule = null;
            vm.selectedObservationId = null;
            vm.numberParameters = null;
            vm.listParameters = null;

            vm.availableExperiments = getExperiments();

            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
        }

        vm.volumes = volumes;
        vm.updateCalendar = updateCalendar;
        vm.update = update;
        vm.updateModule = updateModule;
        vm.updateSelectedObservation = updateSelectedObservation;
        vm.isDurationDisabled = isDurationDisabled;
        vm.onStartDateUpdate = onStartDateUpdate;
        vm.onEndDateUpdate = onEndDateUpdate;
        vm.updateStartDate = updateStartDate;
        vm.updateDuration = updateDuration;
        vm.updateEndDate = updateEndDate;
        vm.onPreserveRatioClick = onPreserveRatioClick;
        vm.updateLettersFrequency = updateLettersFrequency;

        function getPreserveRatio() {
            var defaultValue = "dates";
            if ($cookies.get("preserveRatio") != null) {
                defaultValue = $cookies.get("preserveRatio");
            }

            if (vm.obsDef == null) {
                // If obs to be created, return default or cookie value (if exists)
                return defaultValue;
            } else if (isDurationDisabled()) {
                // If duration is disabled, return "duration"
                return "duration";
            } else {
                // Any other case, return default or cookie value (if exists)
                return defaultValue;
            }
        }

        function onPreserveRatioClick() {
            $cookies.put("preserveRatio", vm.preserveRatio);
        }

        function onStartDateUpdate() {
            if (vm.preserveRatio === "dates") {
                vm.updateDuration();
            } else {
                vm.updateEndDate();
            }
        }

        function onEndDateUpdate() {
            if (vm.preserveRatio === "dates") {
                vm.updateDuration();
            } else {
                vm.updateStartDate();
            }
        }

        function isDurationDisabled() {
            if (vm.obsDef == null) {
                return true;
            }
            return vm.obsDef.duration.valueType !== 'NUMBER' || vm.isEditable === false;
        }

        function volumes() {
            var volumesList = [];
            if (vm.selectedObservation) {
                for (var volume in vm.selectedObservation.volumes) {
                    if (vm.selectedObservation.flows[volume] == null) {
                        volumesList.push(volume);
                    }
                }
            }
            return volumesList;
        }

        function update() {
            vm.clearParameters();
            vm.numberParameters = [];
            vm.listParameters = [];
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
            vm.selectedModule = vm.availableModules[0];
            vm.availableObservations = getObservations();
            vm.evaluatedObservation = null;
            vm.selectedObservation = null;
            vm.obsDef = null;
        }

        function updateModule() {
            vm.clearParameters();
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
            vm.availableObservations = getObservations();
            vm.evaluatedObservation = null;
            vm.selectedObservation = null;
            vm.obsDef = null;
        }

        function updateSelectedObservation() {
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
            vm.availableObservations = getObservations();
            vm.obsDef = vm.observationsPerInstrument[vm.selectedExperiment].allObservations[vm.selectedModule][vm.selectedObservationId];
            vm.selectedObservation = null;
            updateParametersValues();
            if (false === vm.numberParaMetersWrong()) {
                vm.evaluate();
            }
            if (vm.obsDef.duration.valueType !== 'NUMBER') {
                vm.preserveRatio = "duration";
            }
        }

        vm.numberParaMetersWrong = function () {
            if (vm.obsDef == null)
                return true;
            for (var numberParam in vm.obsDef.numberParameters) {
                if (vm.obsDef.numberParameters.hasOwnProperty(numberParam)) {
                    var min = vm.parameterNumberMin[numberParam];
                    var max = vm.parameterNumberMax[numberParam];
                    var value = vm.numberParameterValue[numberParam];
                    if (value == null)
                        return true;
                    if (isNaN(value))
                        return true;
                    if (value > max || value < min)
                        return true;
                }

            }
            return false;
        };

        vm.parametersWrong = function () {
            if (vm.numberParaMetersWrong())
                return true;
            if (vm.invalidateStartDate)
                return true;
            if (vm.invalidateEndDate)
                return true;
            if (vm.durationLettersInvalid())
                return true;
            if (vm.invalidateDateRange())
                return true;
            if (vm.outOfRangeDate())
                return true;
            if (vm.repeatOutOfRangeDate())
                return true;
            if (vm.repeatWrong())
                return true;
            return false;
        };

        vm.invalidateDateRange = function () {
            var endDateMilliseconds = Date.parse(getEndDate()).valueOf();
            var startDateMilliseconds = Date.parse(getStartDate()).valueOf();
            return startDateMilliseconds > endDateMilliseconds;
        };

        vm.outOfRangeDate = function () {
            return vm.startOutOfRangeDate() || vm.endOutOfRangeDate() || vm.repeatOutOfRangeDate();
        };

        vm.endOutOfRangeDate = function () {
            var validEndDate = Date.parse(vm.plan.validityEndTime);
            var endDateMilliseconds = Date.parse(getEndDate()).valueOf();

            return endDateMilliseconds > validEndDate.valueOf();
        };

        vm.startOutOfRangeDate = function () {
            var validStartDate = Date.parse(vm.plan.validityStartTime);
            var startDateMilliseconds = Date.parse(getStartDate()).valueOf();

            return startDateMilliseconds < validStartDate.valueOf();
        };

        vm.repeatOutOfRangeDate = function () {
            if (vm.repeat === false) {
                return false;
            } else {
                var validEndDate = Date.parse(vm.plan.validityEndTime);
                var endDateMilliseconds = Date.parse(vm.lastEndTime).valueOf();
                return endDateMilliseconds > validEndDate.valueOf();
            }
        };

        function updateEndDate() {
            if (SoopkitchenUtils.isValidDate(getStartDate())) {
                vm.invalidateStartDate = false;
            } else {
                vm.invalidateStartDate = true;
                return;
            }
            vm.resetEvaluation();
            var newDate = new Date(Date.parse(getStartDate()).valueOf() + vm.duration * 1000);
            setEndDate(SoopkitchenUtils.formattedDate(newDate));
            if (vm.repeat) {
                var newDateEnd = new Date(Date.parse(getEndDate()).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
                vm.lastEndTime = SoopkitchenUtils.formattedDate(newDateEnd);
            }
            vm.endDateStyle = getCssBlinkingStyle();
            $timeout(function () {
                vm.endDateStyle = null;
            }, vm.blinkingTimeout);
        }

        function updateStartDate() {
            if (SoopkitchenUtils.isValidDate(getEndDate())) {
                vm.invalidateEndDate = false;
            } else {
                vm.invalidateEndDate = true;
                return;
            }
            vm.resetEvaluation();
            var newDate = new Date(Date.parse(getEndDate()).valueOf() - vm.duration * 1000);
            setStartDate(SoopkitchenUtils.formattedDate(newDate));
            vm.startDateStyle = getCssBlinkingStyle();
            $timeout(function () {
                vm.startDateStyle = null;
            }, vm.blinkingTimeout);
        }

        function getObsDef(obs) {
            if (obs) {
                return vm.observationsPerInstrument[obs.experiment].allObservations[obs.module][obs.name];
            }
        }

        function repeatWrong() {
            if (vm.repeat === false) {
                return false;
            } else {
                return vm.frequency < vm.duration;
            }
        }

        function getObservations() {
            var observationsSet = new Set();
            var selectedObservations = vm.observationsPerInstrument[vm.selectedExperiment].allObservations[vm.selectedModule];
            for (var obsType in selectedObservations) {
                if (selectedObservations.hasOwnProperty(obsType)) {
                    observationsSet.add(obsType);
                }
            }
            return Array.from(observationsSet);
        }

        function updateParametersValues() {
            vm.clearParameters();
            vm.numberParameters = getNumberParameters();
            vm.listParameters = getListParameters();
            if (vm.obsDef != null) {
                for (var numberParam in vm.obsDef.numberParameters) {
                    if (vm.selectedObservation != null) {
                        vm.numberParameterValue[numberParam] = vm.selectedObservation.numberParameters[numberParam];
                    } else {
                        vm.numberParameterValue[numberParam] = vm.obsDef.numberParameters[numberParam].numberValue;
                    }
                    vm.parameterNumberUnit[numberParam] = vm.obsDef.numberParameters[numberParam].unit;
                    vm.parameterNumberMin[numberParam] = vm.obsDef.numberParameters[numberParam].min;
                    vm.parameterNumberMax[numberParam] = vm.obsDef.numberParameters[numberParam].max;
                }
                for (var listParam in vm.obsDef.listParameters) {
                    if (vm.selectedObservation != null) {
                        vm.listParameterValue[listParam] = vm.selectedObservation.listParameters[listParam];
                    } else {
                        vm.listParameterValue[listParam] = vm.obsDef.listParameters[listParam].value;
                    }
                    vm.listParameterAvailableValues[listParam] = vm.obsDef.listParameters[listParam].values
                }
                if (vm.selectedObservation != null) {
                    vm.duration = vm.selectedObservation.duration;
                    vm.comment = vm.selectedObservation.comment;
                } else {
                    vm.duration = vm.obsDef.duration.numberValue;
                }
                vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            }
        }

        function getExperiments() {
            var groupsSet = new Set();

            for (var experiment in vm.observationsPerInstrument) {
                if (vm.observationsPerInstrument.hasOwnProperty(experiment)) {
                    groupsSet.add(experiment);
                }
            }
            return Array.from(groupsSet);
        }

        function getNumberParameters() {
            var parametersSet = new Set();
            if (vm.obsDef == null) {
                return Array.from(parametersSet);
            } else {
                for (var parameters in vm.obsDef.numberParameters) {
                    if (vm.obsDef.numberParameters.hasOwnProperty(parameters)) {
                        parametersSet.add(parameters);
                    }
                }
            }
            return Array.from(parametersSet);
        }

        function getListParameters() {
            var parametersSet = new Set();
            if (vm.obsDef == null) {
                return Array.from(parametersSet);
            } else {
                for (var parameter in vm.obsDef.listParameters) {
                    if (vm.obsDef.listParameters.hasOwnProperty(parameter)) {
                        parametersSet.add(parameter);
                    }
                }
            }
            return Array.from(parametersSet);
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.reset = function () {
            vm.evaluatedObservation = null;
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
            vm.availableObservations = getObservations();
            vm.clearParameters();
            vm.numberParameters = getNumberParameters();
            vm.listParameters = getListParameters();
            for (var numberParam in vm.obsDef.numberParameters) {
                vm.numberParameterValue[numberParam] = vm.obsDef.numberParameters[numberParam].numberValue;
                vm.parameterNumberUnit[numberParam] = vm.obsDef.numberParameters[numberParam].unit;
                vm.parameterNumberMin[numberParam] = vm.obsDef.numberParameters[numberParam].min;
                vm.parameterNumberMax[numberParam] = vm.obsDef.numberParameters[numberParam].max;
            }
            for (var listParam in vm.obsDef.listParameters) {
                vm.listParameterValue[listParam] = vm.obsDef.listParameters[listParam].value;
                vm.listParameterAvailableValues[listParam] = vm.obsDef.listParameters[listParam].values
            }
            vm.duration = vm.obsDef.duration.numberValue;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            var newDate = new Date(Date.parse(getStartDate()).valueOf() + vm.duration * 1000);
            setEndDate(SoopkitchenUtils.formattedDate(newDate));
            vm.evaluate();
        };

        vm.resetDisabled = function () {
            return vm.isEditable === false || vm.selectedObservation == null;
        };

        vm.evaluateDisabled = function () {
            return (vm.isEditable === false || vm.evaluatedObservation != null || vm.parametersWrong());
        };

        vm.soopsSelectedSOOPToRemove = function () {
            for (var i = 0; i < vm.soopBelonging.length; i++) {
                if (vm.soopBelonging [i] === true) {
                    return true;
                }
            }
            return false;
        };
        var canSave = function () {
            return vm.isEditable === false || vm.evaluatedObservation == null || vm.repeatOutOfRangeDate();
        };

        var canDelete = function () {
            return vm.isEditable === false || vm.operation === 'Create';
        };

        var checkDisabled = function (canPerform) {
            return function () {
                if ((vm.isMaster || vm.isChild) && !vm.isSocUser) {
                    var hasInstrument = vm.userInstruments.indexOf(vm.selectedExperiment) >= 0;
                    if (parameters.occurrence) {
                        hasInstrument = hasInstrument && vm.userInstruments.indexOf(parameters.occurrence.experiment) >= 0;
                    }
                    if (hasInstrument) {
                        return canPerform();
                    } else {
                        return true;
                    }
                } else {
                    return canPerform();
                }
            }
        };

        vm.saveDisabled = checkDisabled(canSave);

        vm.deleteDisabled = checkDisabled(canDelete);

        vm.evaluate = function () {

            var params = {
                "obsDefLabel": vm.plan.observationDefinitions.label,
                "experiment": vm.selectedExperiment,
                "obsModule": vm.selectedModule,
                "obsName": vm.obsDef.name,
                "startTime": getStartDate(),
                "endTime": getEndDate(),
                "overwrittenNumberParams": vm.numberParameterValue,
                "overwrittenListParams": vm.listParameterValue,
                "comment": vm.comment
            };

            if (vm.obsDef.duration.valueType !== 'NUMBER' || getStartDate() === getEndDate()) {
                params = {
                    "obsDefLabel": vm.plan.observationDefinitions.label,
                    "experiment": vm.selectedExperiment,
                    "obsModule": vm.selectedModule,
                    "obsName": vm.obsDef.name,
                    "startTime": getStartDate(),
                    "overwrittenNumberParams": vm.numberParameterValue,
                    "overwrittenListParams": vm.listParameterValue,
                    "comment": vm.comment
                }
            }

            $http({
                method: 'POST',
                url: 'api/obsInstance',
                params: params

            }).then(function successCallback(response) {
                AlertService.success("Evaluation of Observation successful");
                vm.evaluatedObservation = response.data;

                vm.selectedObservationId = vm.evaluatedObservation.name;
                vm.selectedObservation = vm.evaluatedObservation;
                vm.obsDef = vm.getObsDef(vm.evaluatedObservation);
                vm.selectedModule = vm.evaluatedObservation.module;
                setStartDate(vm.evaluatedObservation.startDate);
                setEndDate(vm.evaluatedObservation.endDate);
                updateParametersValues();
                updateLettersFrequency ();

            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        };


        vm.save = function () {
            if ((parameters.occurrence != null) && vm.cut) {
                updateObservationInPlan();
            } else {
                saveObservationInPlan();
            }
        };

        function removeFromSOOP(soopInstances) {
            Planning.detatchFromSoop(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                    soopInstances: soopInstances
                }, [parameters
                    .occurrence],
                function successCallback(data) {
                    AlertService.success("Detached Observation from SOOPS " + JSON.stringify(soopInstances));
                    updateTimeLine(true, data);
                    $uibModalInstance.dismiss('cancel');
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                });
        }

        vm.detachSOOP = function () {
            var count = 0;
            var selectedSOOPs = [];
            var unselectedSOOPs = [];
            vm.soopsItBelongs.forEach(function (soop) {
                if (vm.soopBelonging[count]) {
                    selectedSOOPs.push(soop)
                } else {
                    unselectedSOOPs.push(soop)
                }
                count++;
            });
            var soopMap = {};
            selectedSOOPs.forEach(function (soop) {
                soopMap[soop.encodedSoopType] = soop.soopInstanceId;
            });
            removeFromSOOP(soopMap);
        };
        
        vm.autonomize = function () {

            Planning.autonomizeFromSoop(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                }, [parameters.occurrence],
                function successCallback(data) {
                    AlertService.success("Autonomized Observation");
                    updateTimeLine(true);
                    $uibModalInstance.dismiss('cancel');
                }, function errorCallback(data) {
                    AlertService.error("Error autonomizing Observation from SOOPs")
                });
        };

        vm.deautonomize = function () {
            removeFromSOOP({'000': '000'});
        };

        vm.isIndependent = function () {
            for (var i = 0; i < vm.ids.length; i++) {
                var idComponents = vm.ids[i].split('_');
                if (idComponents[2] === "000" && idComponents[3] === "000") {
                    return true;
                }
            }
            return false;
        };

        function saveObservationInPlan() {
            var obsList = [];
            if (vm.repeat === false) {
                var observation = vm.evaluatedObservation;
                obsList.push(observation);
            } else {
                for (var occurrence = 0; occurrence < vm.numberOccurences; occurrence++) {
                    var newObservation = JSON.parse(JSON.stringify(vm.evaluatedObservation));
                    var newStartDate = new Date(Date.parse(getStartDate()).valueOf() + vm.frequency * (occurrence) * 1000);
                    var newEndDate = new Date(Date.parse(getEndDate()).valueOf() + vm.frequency * (occurrence) * 1000);
                    newObservation.startDate = newStartDate;
                    newObservation.endDate = newEndDate;
                    obsList.push(newObservation);
                }
            }
            vm.waiting = true;
            Planning.addObsInstance(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                },
                obsList,
                function successCallback(data) {
                    vm.waiting = false;
                    var startStr = vm.evaluatedObservation.startDate;
                    var endStr = vm.evaluatedObservation.endDate;
                    if (vm.isTimelineWithNoDates) {
                        startStr = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.evaluatedObservation.startDate);
                        endStr = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.evaluatedObservation.endDate);
                    }
                    AlertService.success("Added Observation " + vm.evaluatedObservation.name + " : " + startStr + " --> " + endStr + " to Plan successfully");
                    updateTimeLine(true, data);
                    $uibModalInstance.dismiss('cancel');
                },
                function errorCallback(response) {
                    vm.waiting = false;
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function updateObservationInPlan() {
            var existingObs = parameters.occurrence;
            updateObservation(existingObs, vm.evaluatedObservation, function (data) {
                var startStr = vm.evaluatedObservation.startDate;
                var endStr = vm.evaluatedObservation.endDate;
                if (vm.isTimelineWithNoDates) {
                    startStr = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.evaluatedObservation.startDate);
                    endStr = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.evaluatedObservation.endDate);
                }
                AlertService.success("Updated Observation " + vm.evaluatedObservation.name + " : " + startStr + " --> " + endStr + " to Plan successfully");
                updateTimeLine(true, data);
                $uibModalInstance.dismiss('cancel');
            });
        }


        function updateObservation(existingObs, updatedObs, success) {
            var listObservations = [];
            listObservations.push(
                {
                    "updatedHappening": updatedObs,
                    "existingHappening": existingObs
                }
            );
            vm.waiting = true;
            Planning.updateObsInstance(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                },
                {"updateList": listObservations},
                function successCallback(data) {
                    vm.waiting = false;
                    if (success != null) {
                        success(data);
                    }
                },
                function errorCallback(response) {
                    vm.waiting = false;
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function updateTimeLine(highlightOccurrance, data) {
            
            if (highlightOccurrance) {
                $rootScope.$broadcast('updateList', {
                    newOccurrance: vm.evaluatedObservation,
                    oldOccurrance: parameters.occurrence,
                    data: data
                });

            } else {
                SoopkitchenUtils.updatePlanFromDialog(data);
                $uibModalInstance.dismiss('cancel');

            }
        }

        vm.updateLetters = function () {
            vm.resetEvaluation();
            vm.duration = SoopkitchenUtils.timeToSeconds(vm.durationLetters);
            var newDate = new Date(Date.parse(getStartDate()).valueOf() + vm.duration * 1000);
            setEndDate(SoopkitchenUtils.formattedDate(newDate));
            blinkDuration(false, true);
        };

        function updateLettersFrequency () {
            vm.frequency = SoopkitchenUtils.timeToSeconds(vm.durationLettersFrequency);
            var newDate = new Date(Date.parse(getEndDate()).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
            vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
        }

        
        function clearParameters() {
            vm.parameterNumberUnit = {};
            vm.numberParameterValue = {};
            vm.listParameterValue = {};
            vm.listParameterAvailableValues = {};
            vm.parameterNumberMin = {};
            vm.parameterNumberMax = {};
            vm.numberParameters = [];
            vm.listParameters = [];
            vm.duration = null;
            vm.comment = "";
            vm.durationLetters = null;
        }

        function updateCalendar() {
            vm.resetEvaluation();
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            var newDate = new Date(Date.parse(getStartDate()).valueOf() + vm.duration * 1000);
            setEndDate(SoopkitchenUtils.formattedDate(newDate));
            if (vm.repeat) {
                vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
            }
            blinkDuration(true, false);
        }

        function blinkDuration(blinkDurationLetters, blinkDuration) {
            if (blinkDurationLetters) {
                vm.durationLettersStyle = getCssBlinkingStyle();
            }
            if (blinkDuration) {
                vm.durationStyle = getCssBlinkingStyle();
            }
            $timeout(function () {
                vm.durationLettersStyle = null;
                vm.durationStyle = null;
            }, vm.blinkingTimeout);
        }

        function updateDuration() {
            if (SoopkitchenUtils.isValidDate(getStartDate())) {
                vm.invalidateStartDate = false;
                vm.resetEvaluation();
                if (SoopkitchenUtils.isValidDate(getEndDate())) {
                    vm.invalidateEndDate = false;
                } else {
                    vm.invalidateEndDate = true;
                    return;
                }
                vm.duration = (Date.parse(getEndDate()) - Date.parse(getStartDate())) / 1000;
                vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
                blinkDuration(true, true);
            } else {
                vm.invalidateStartDate = true;
            }
        }

        function getStartDate() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.plan.validityStartTime, vm.startDate);
            } else {
                return vm.startDate;
            }
        }

        function setStartDate(date) {
            if (vm.isTimelineWithNoDates) {
                vm.startDate = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, date);
            } else {
                vm.startDate = date;
            }
        }

        function getEndDate() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.plan.validityStartTime, vm.endDate);
            } else {
                return vm.endDate;
            }
        }

        function setEndDate(date) {
            if (vm.isTimelineWithNoDates) {
                vm.endDate = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, date);
            } else {
                vm.endDate = date;
            }
        }

        function belongsToASOOP() {
            if (parameters.occurrence != null && parameters.occurrence.hasOwnProperty('compositeId')) {
                var compositeSoopIds = parameters.occurrence.compositeId.compositeSoopIds;
                for (var i = 0; i < compositeSoopIds.length; i++) {
                    if (compositeSoopIds[i].soopInstanceId !== '000') {
                        return true;
                    }
                }
            }
            return false;
        }

        function getSOOPsItBelongs() {
            var soops = [];
            if (parameters.occurrence != null && parameters.occurrence.hasOwnProperty('compositeId')) {
                var compositeSoopIds = parameters.occurrence.compositeId.compositeSoopIds;
                for (var i = 0; i < compositeSoopIds.length; i++) {
                    if (compositeSoopIds[i].soopInstanceId !== '000') {
                        soops.push(compositeSoopIds[i]);
                    }
                }
            }
            return soops;
        }

        function getCssBlinkingStyle() {
            return {
                'animation': 'blinker 1s linear infinite',
                'color': 'blue'
            };
        }

        function resetEvaluation() {
            vm.evaluatedObservation = null;
        }

        vm.durationLettersInvalid = function () {
            if (vm.durationLetters == null)
                return false;
            return (SoopkitchenUtils.timeToSeconds(vm.durationLetters) === 0 || isNaN(SoopkitchenUtils
                .timeToSeconds(vm.durationLetters)));
        };

        vm.durationLettersInvalidFrequency = function () {
            if (vm.durationLettersFrequency == null)
                return false;
            return (SoopkitchenUtils.timeToSeconds(vm.durationLettersFrequency) === 0 || isNaN(SoopkitchenUtils
                .timeToSeconds(vm.durationLettersFrequency)));
        };

        function getValidityRange() {
            if (vm.isTimelineWithNoDates) {
                return ' -> ' + SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.plan.validityEndTime);
            } else {
                return vm.plan.validityStartTime + ' -> ' + vm.plan.validityEndTime;
            }
        }

        vm.deleteObservation = function () {
            SoopkitchenUtils.prettyConfirm('Remove item', 'Do you really want to remove the observation '
                + vm.occurrence.name + ' with start date ' + vm.occurrence.startDate + ' ? ', function (ok) {
                if (ok) {
                    var occurrences = [];
                    occurrences.push(vm.occurrence);
                    Planning.deleteObsInstance(
                        {
                            planType: vm.planType,
                            planLabel: vm.plan.label
                        },
                        occurrences,
                        function successCallback(data) {
                            updateTimeLine(false, data);
                            $uibModalInstance.dismiss('cancel');
                            AlertService.success("Deleted Observation successfully");
                        }, function (response) {
                            SoopkitchenUtils.prettyError(response);
                        }
                    );
                }
            });
        }
    }
})();
